export default __webpack_public_path__ + "static/media/eb-wht-banner-2.25773047.jpg";